<template lang="pug">
  .offers
    v-container.white.px-4(style="max-width:600px")
      v-card.my-3.mt-2(flat outlined)
        //- Bundle
        div.clickable.d-flex.align-center.py-4.px-6(@click="showBundleDialog = true")
          div.my-auto
            div.s1.basic800--text {{ $t('bundle') }}
              v-chip.c1.white--text.ml-2.px-2(height="18" x-small color="info400") {{ $t('new') }}!
              //- v-chip.c1.white--text.ml-2.px-2(v-if="Auth('component', '/admin/offers#product_bundle')" height="18" x-small color="info400") New!
              //- v-chip.c1.white--text.ml-2.px-2(v-else height="18" x-small color="basic600") For growth plan only
            div.c1.basic600--text {{ $t('bundle_text') }}
          v-spacer
          eva-icon(name="arrow-ios-forward-outline")

        v-divider.basic300

        //- Coupons
        div.clickable.d-flex.align-center.py-4.px-6(@click="showCouponDialog = true")
          div.my-auto
            div.s1.basic800--text {{ $t('coupons') }}
            div.c1.basic600--text {{ $t('coupons_text') }}
          v-spacer
          eva-icon(name="arrow-ios-forward-outline")

    .modals
      coupons(v-if="showCouponDialog" :open.sync="showCouponDialog")
      bundle(v-if="showBundleDialog" :open.sync="showBundleDialog")

</template>

<script>
import Coupons from '@/components/offers/dialogs/coupons/Coupons.vue'
import Bundle from '@/components/offers/dialogs/bundles/Bundle.vue'

export default {
  name: 'Offers',
  components: {
    Coupons, Bundle
  },
  data () {
    return {
      showCouponDialog: false,
      showBundleDialog: false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "bundle_text": "Offer discounted price for bundle of item",
    "coupons_text": "Generate coupon codes for your customers"
  },
  "id": {
    "bundle_text": "Menawarkan harga diskon untuk Bundle item",
    "coupons_text": "Buatkan kode kupon untuk pelanggan kamu"
  }
}
</i18n>